import { render, staticRenderFns } from "./CartRight.vue?vue&type=template&id=94a10f58"
import script from "./CartRight.vue?vue&type=script&lang=js"
export * from "./CartRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports